import { useQuery } from '@tanstack/react-query';
import { driverApi } from '../services/driverApi';
import { useHybridAuth } from './useHybridAuth';
import { useUserCompanies } from './useUserCompanies';

/**
 * The company's storage lots (GET /locations), for choosing where an
 * impound goes. Any member may list them; the active ones are offered.
 */
export const useLocations = (enabled = true) => {
  const { getAccessTokenSilently } = useHybridAuth();
  const { selectedCompanyId } = useUserCompanies();
  return useQuery({
    queryKey: ['locations', selectedCompanyId],
    queryFn: async () => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      const locations = await driverApi.getLocations();
      return locations.filter((location) => location.isActive !== false);
    },
    enabled: enabled && !!selectedCompanyId,
    staleTime: 5 * 60 * 1000,
  });
};
